import styled from "styled-components";

import React, { useContext, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import Icon from "./Icon";

import User from "../types/User";
import FlexBox, { FlexBoxProps, FlexGrow } from "./FlexBox";
import _theme from "../styles/theme";
import Dropdown, { DropdownContainer, DropdownItem } from "./Dropdown";
import { UserContext } from "../context/UserContext";
import SemesterSelect from "./SemesterSelect";
import theme from "../styles/theme";
import { useLocation } from "react-router-dom";
import ProgramSelect from "./ProgramSelect";
import ExploreMergedSelects from "./ExploreMergedSelects";

const StyledNavbar = styled(FlexBox)<
  { isMobile?: boolean; isOpen: boolean } & FlexBoxProps
>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 74px;
  background-color: #0c0d22;
  z-index: 999;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme, isMobile }) =>
    `${theme.spacing.x2} ${isMobile ? theme.spacing.x2 : theme.spacing.x4}`};
  margin-left: ${({ isOpen }) =>
    isOpen ? theme.sidebarWidth : `calc(${theme.sidebarWidth} - 180px)`};
  box-sizing: border-box;
`;
export const ProfileTag = styled.button<
  { isMobile?: boolean } & React.HTMLProps<HTMLButtonElement>
>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  border-radius: 0;

  &:hover {
    border-radius: 50px;
    background-color: inherit;
  }

  &:focus-visible {
    outline: 2px #000 solid;
    outline-style: auto;
  }
`;

export type NavbarProps = {
  children?: React.ReactNode;
  user?: User;
  onSidebarToggle?: (arg0: unknown) => void;
  showSignout?: boolean;
  isOpen: boolean;
};

function Navbar({
  user,
  children,
  onSidebarToggle,
  showSignout,
  isOpen,
}: NavbarProps): JSX.Element {
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );

  const location = useLocation();
  const { isSignedIn } = useContext(UserContext);
  const role = JSON.parse(localStorage.getItem("role") as string);

  const isExplore = location.pathname.includes("/explore");
  const isInstructorCompetencies = location.pathname.includes(
    "/instructor-competencies"
  );
  const isInstructorOrAdmin = role?.role !== 1;

  return (
    <>
      <StyledNavbar space={5} isMobile={isMobile} isOpen={isOpen}>
        {isSignedIn && (
          <>
            <FlexBox style={{ display: "flex", gap: 10 }}>
              {(isExplore && isInstructorOrAdmin) || (isInstructorCompetencies && isInstructorOrAdmin) ? (
                <ExploreMergedSelects />
              ) : (
                <>
                  {/* {isInstructorCompetencies && isInstructorOrAdmin && (
                    <FlexGrow style={{ margin: 0 }}>
                      <ProgramSelect />
                    </FlexGrow>
                  )} */}
                  <FlexGrow style={{ margin: 0 }}>
                    <SemesterSelect />
                  </FlexGrow>
                </>
              )}
            </FlexBox>
            <DropdownContainer>
              <ProfileTag
                style={{
                  width: "40px",
                  height: "40px",
                  justifyContent: "center",
                  background:
                    "linear-gradient( 90deg, rgb(176,52,52) 0%, rgb(24,75,104) 118.29% )",
                  borderRadius: "50%",
                }}
                isMobile={isMobile}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsProfileDropdownOpen(!isProfileDropdownOpen);
                }}
              >
                <Icon color="white" fixedWidth={false} name="user"></Icon>
              </ProfileTag>
              <Dropdown
                open={isProfileDropdownOpen}
                setOpen={setIsProfileDropdownOpen}
                align="right"
                style={{ minWidth: `${_theme.spacing.base * 25}px` }}
              >
                <DropdownItem style={{ color: "black" }} to="/signout">
                  <Icon mr={1} name="exit" />
                  Sign out
                </DropdownItem>
              </Dropdown>
            </DropdownContainer>
          </>
        )}
      </StyledNavbar>
    </>
  );
}

export default Navbar;
